import { AxiosResponse } from 'axios'
import { del, get, patch, post, upload } from '../../utils/api'

export const fetchParents = (): Promise<AxiosResponse> =>
  get('/me/profile/parents')

export const createParent = (
  gender: 'male' | 'female',
  first_name?: string,
  middle_name?: string,
  last_name?: string,
  birthdate?: string,
  contact_email?: string,
  contact_phone?: string
): Promise<AxiosResponse> =>
  post('/me/profile/parents', {
    gender,
    first_name,
    middle_name,
    last_name,
    birthdate,
    contact_email,
    contact_phone,
  })

export const editParent = (
  parent_id: string,
  gender?: 'male' | 'female',
  first_name?: string,
  middle_name?: string,
  last_name?: string,
  birthdate?: string,
  contact_email?: string,
  contact_phone?: string
): Promise<AxiosResponse> =>
  patch(`/me/profile/parents/${parent_id}`, {
    gender,
    first_name,
    middle_name,
    last_name,
    birthdate,
    contact_email,
    contact_phone,
  })

export const uploadPhoto = (
  parent_id: string,
  photo: File
): Promise<AxiosResponse> =>
  upload(`/me/profile/parents/${parent_id}/photo`, {
    field: 'photo',
    item: photo,
  })

export const removePhoto = (parent_id: string): Promise<AxiosResponse> =>
  del(`/me/profile/parents/${parent_id}/photo`)
